export default __webpack_public_path__ + "static/media/Spine of Dagon.081c3f54.jpg";